import { connect } from "react-redux";

import {default as AdvertisingTableV} from "./AdvertisingTable";
import {default as AdvertisingSearchV} from "./AdvertisingSearch";







export const AdvertisingList = connect(null, null )(AdvertisingTableV);
export const AdvertisingSearch =  connect(null, null )(AdvertisingSearchV);